"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _RevieveFoundationFinder = require("./RevieveFoundationFinder");
Object.keys(_RevieveFoundationFinder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RevieveFoundationFinder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RevieveFoundationFinder[key];
    }
  });
});